import { Exercise as ComponentExercise } from "@/services/admin/exercises.interfaces";
import { LucideIcon } from "lucide-react";
import { CardInfo } from "./types";

/**
 * Classe base para todos os editores de exercícios
 * Esta interface consolida as funcionalidades de IEditorInterface.ts e IExerciseEditor.ts
 */
export abstract class EditorInterface {
  /**
   * Retorna as informações para exibir no cartão do exercício
   * @param exercise Objeto do exercício
   */
  static GetCardInfo(exercise: ComponentExercise): CardInfo {
    return {
      title: 'Exercício',
      subtitle: 'Sem detalhes',
    };
  }
  
  /**
   * Retorna o título do tipo de exercício
   */
  static getTitle(): string {
    return 'Exercício';
  }
  
  /**
   * Retorna uma descrição do exercício formatada para exibição
   * @param exercise Objeto do exercício
   */
  static getDescription(exercise: ComponentExercise): string {
    return 'Sem detalhes disponíveis';
  }
  
  /**
   * Retorna o ícone correspondente ao tipo do exercício
   */
  static getIcon(): LucideIcon | null {
    return null;
  }
  
  /**
   * Verifica se o editor suporta um determinado tipo de exercício
   * @param type Tipo do exercício
   */
  static SupportsExerciseType(type: string): boolean {
    return false;
  }
}